// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1wfuA","detailsBorder":"styles_detailsBorder__2ULpB"};